<svg
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <defs>
    <symbol id="twoFeet" viewBox="0 0 314.22 257.85">
      <g>
        <g fill="#58c7d9">
          <ellipse
            cx="89.03"
            cy="23.95"
            rx="14.85"
            ry="23.01"
            transform="rotate(-3.43 89.04 23.893)"
          />
          <ellipse
            cx="57.56"
            cy="29.95"
            rx="8.46"
            ry="13.96"
            transform="rotate(-8.1 56.084 28.739)"
          />
          <ellipse
            cx="35.5"
            cy="39.98"
            rx="7.72"
            ry="12.03"
            transform="rotate(-15.42 35.47 39.967)"
          />
          <ellipse
            cx="18.79"
            cy="55.84"
            rx="6.38"
            ry="10.99"
            transform="rotate(-19.47 18.8 55.849)"
          />
          <ellipse
            cx="6.04"
            cy="75.08"
            rx="5.49"
            ry="8.91"
            transform="rotate(-21.02 6.06 75.087)"
          />
          <path
            d="M11.68 116.23S20.73 165.8 29 224.46c1.68 12 10.4 37.5 33.64 32.83 28-5.62 20.2-33.65 11.66-58.44-8.47-24.56-20.48-47.09-5.55-61.9 21.9-21.75 35.25-29.22 31.45-58.52-4.39-33.75-46.87-24.11-65.32-8.79S9 101.31 11.68 116.23z"
          />
          <ellipse
            cx="226.97"
            cy="22.95"
            rx="23.01"
            ry="14.85"
            transform="rotate(-84.53 226.971 22.95)"
          />
          <ellipse
            cx="258.2"
            cy="30.06"
            rx="13.96"
            ry="8.46"
            transform="rotate(-79.58 258.215 30.06)"
          />
          <ellipse
            cx="279.89"
            cy="40.88"
            rx="12.03"
            ry="7.72"
            transform="rotate(-72.54 279.91 40.869)"
          />
          <ellipse
            cx="296.03"
            cy="57.32"
            rx="10.99"
            ry="6.38"
            transform="rotate(-68.49 296.01 57.326)"
          />
          <ellipse
            cx="308.08"
            cy="77"
            rx="8.91"
            ry="5.49"
            transform="rotate(-66.94 308.061 77.008)"
          />
          <path
            d="M301 117.92s-10.81 49.22-21.13 107.55c-2.1 11.92-11.72 37.1-34.79 31.61-27.76-6.61-19-34.35-9.56-58.82 9.33-24.24 22.14-46.33 7.75-61.66C222.1 114.08 209 106.14 213.86 77c5.59-33.58 47.7-22.43 65.6-6.46s24.7 32.57 21.54 47.38z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="person" viewBox="0 0 24 24">
      <path
        fill="#49E400"
        d="M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M10.5,7H13.5A2,2 0 0,1 15.5,9V14.5H14V22H10V14.5H8.5V9A2,2 0 0,1 10.5,7Z"
      />
    </symbol>
    <!-- <symbol id="eyeOpen" viewBox="0 0 24 24">
      <path
        d="M12 9a3 3 0 0 1 3 3 3 3 0 0 1-3 3 3 3 0 0 1-3-3 3 3 0 0 1 3-3m0-4.5c5 0 9.27 3.11 11 7.5-1.73 4.39-6 7.5-11 7.5S2.73 16.39 1 12c1.73-4.39 6-7.5 11-7.5M3.18 12a9.821 9.821 0 0 0 17.64 0 9.821 9.821 0 0 0-17.64 0z"
      />
    </symbol> -->
    <symbol id="eyeOpen" viewBox="0 0 24 24">
      <!-- Eyelids -->
      <path
        fill="#58c7d9"
        d="M12 4.5c5 0 9.27 3.11 11 7.5-1.73 4.39-6 7.5-11 7.5S2.73 16.39 1 12c1.73-4.39 6-7.5 11-7.5M3.18 12a9.821 9.821 0 0 0 17.64 0 9.821 9.821 0 0 0-17.64 0z"
      />
      <!-- Pupil -->
      <path
        fill="#9bf09d"
        d="M12 9a3 3 0 0 1 3 3 3 3 0 0 1-3 3 3 3 0 0 1-3-3 3 3 0 0 1 3-3"
      />
    </symbol>
    <symbol id="eyeShut" viewBox="0 0 24 24">
      <path
        d="M2,5.27L3.28,4L20,20.72L18.73,22L15.65,18.92C14.5,19.3 13.28,19.5 12,19.5C7,19.5 2.73,16.39 1,12C1.69,10.24 2.79,8.69 4.19,7.46L2,5.27M12,9A3,3 0 0,1 15,12C15,12.35 14.94,12.69 14.83,13L11,9.17C11.31,9.06 11.65,9 12,9M12,4.5C17,4.5 21.27,7.61 23,12C22.18,14.08 20.79,15.88 19,17.19L17.58,15.76C18.94,14.82 20.06,13.54 20.82,12C19.17,8.64 15.76,6.5 12,6.5C10.91,6.5 9.84,6.68 8.84,7L7.3,5.47C8.74,4.85 10.33,4.5 12,4.5M3.18,12C4.83,15.36 8.24,17.5 12,17.5C12.69,17.5 13.37,17.43 14,17.29L11.72,15C10.29,14.85 9.15,13.71 9,12.28L5.6,8.87C4.61,9.72 3.78,10.78 3.18,12Z"
      />
    </symbol>
    
    <symbol id="checkCircle" viewBox="0 0 24 24">
      <path
        d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z"
      />
    </symbol>
    <symbol id="alert" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
      />
    </symbol>
    <symbol id="redo" viewBox="0 0 24 24">
      <path
        d="M10.5,7A6.5,6.5 0 0,0 4,13.5A6.5,6.5 0 0,0 10.5,20H14V18H10.5C8,18 6,16 6,13.5C6,11 8,9 10.5,9H16.17L13.09,12.09L14.5,13.5L20,8L14.5,2.5L13.08,3.91L16.17,7H10.5M18,18H16V20H18V18Z"
      />
    </symbol>
    <symbol id="record" viewBox="0 0 24 24">
      <path
        d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7Z"
      />
    </symbol>
    <symbol id="leftArrowCircle" viewBox="0 0 24 24">
      <path
        d="M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M18,11H10L13.5,7.5L12.08,6.08L6.16,12L12.08,17.92L13.5,16.5L10,13H18V11Z"
      />
    </symbol>
    <symbol id="compare" viewBox="0 0 24 24">
      <path
        d="M19,3H14V5H19V18L14,12V21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10,18H5L10,12M10,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H10V23H12V1H10V3Z"
      />
    </symbol>
    <symbol id="close" viewBox="0 0 24 24">
      <path
        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
      />
    </symbol>
    <symbol id="rightFoot" viewBox="0 0 102.2 257.85">
      <g>
        <g>
          <ellipse
            cx="14.94"
            cy="22.95"
            rx="23.01"
            ry="14.85"
            transform="rotate(-84.53 14.943 22.953)"
          />
          <ellipse
            cx="46.18"
            cy="30.06"
            rx="13.96"
            ry="8.46"
            transform="rotate(-79.58 46.183 30.066)"
          />
          <ellipse
            cx="67.87"
            cy="40.88"
            rx="12.03"
            ry="7.72"
            transform="rotate(-72.54 67.877 40.874)"
          />
          <ellipse
            cx="84.01"
            cy="57.32"
            rx="10.99"
            ry="6.38"
            transform="rotate(-68.49 83.997 57.32)"
          />
          <ellipse
            cx="96.06"
            cy="77"
            rx="8.91"
            ry="5.49"
            transform="rotate(-66.94 96.046 76.998)"
          />
          <path
            d="M89 117.92s-10.85 49.22-21.17 107.55c-2.11 11.92-11.73 37.1-34.83 31.61-27.77-6.61-19-34.35-9.57-58.82 9.34-24.24 22.14-46.33 7.75-61.66C10.08 114.08-3 106.14 1.84 77c5.59-33.58 47.7-22.43 65.59-6.46S92.14 103.11 89 117.92z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="leftFoot" viewBox="0 0 103.91 256.89">
      <g>
        <g>
          <ellipse
            cx="89.03"
            cy="22.99"
            rx="14.85"
            ry="23.01"
            transform="rotate(-3.43 89.065 23.058)"
          />
          <ellipse
            cx="57.56"
            cy="28.99"
            rx="8.46"
            ry="13.96"
            transform="rotate(-8.38 57.504 28.983)"
          />
          <ellipse
            cx="35.5"
            cy="39.02"
            rx="7.72"
            ry="12.03"
            transform="rotate(-15.42 35.49 38.991)"
          />
          <ellipse
            cx="18.79"
            cy="54.88"
            rx="6.38"
            ry="10.99"
            transform="rotate(-19.47 18.785 54.886)"
          />
          <ellipse
            cx="6.04"
            cy="74.12"
            rx="5.49"
            ry="8.91"
            transform="rotate(-21.02 6.04 74.136)"
          />
          <path
            d="M11.68 115.26S20.73 164.84 29 223.5c1.68 12 10.4 37.49 33.64 32.82 28-5.62 20.2-33.65 11.66-58.44-8.5-24.56-20.51-47.09-5.58-61.88 21.93-21.75 35.3-29.22 31.48-58.52-4.39-33.76-46.87-24.12-65.32-8.79S9 100.34 11.68 115.26z"
          />
        </g>
      </g>
    </symbol>
    <symbol id="personWalking" viewBox="0 0 24 24">
      <path
        d="M14.12,10H19V8.2H15.38L13.38,4.87C13.08,4.37 12.54,4.03 11.92,4.03C11.74,4.03 11.58,4.06 11.42,4.11L6,5.8V11H7.8V7.33L9.91,6.67L6,22H7.8L10.67,13.89L13,17V22H14.8V15.59L12.31,11.05L13.04,8.18M14,3.8C15,3.8 15.8,3 15.8,2C15.8,1 15,0.2 14,0.2C13,0.2 12.2,1 12.2,2C12.2,3 13,3.8 14,3.8Z"
      />
    </symbol>
    <symbol id="rotate" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12,5C16.97,5 21,7.69 21,11C21,12.68 19.96,14.2 18.29,15.29C19.36,14.42 20,13.32 20,12.13C20,9.29 16.42,7 12,7V10L8,6L12,2V5M12,19C7.03,19 3,16.31 3,13C3,11.32 4.04,9.8 5.71,8.71C4.64,9.58 4,10.68 4,11.88C4,14.71 7.58,17 12,17V14L16,18L12,22V19Z"
      />
    </symbol>
    <symbol id="duration" viewBox="0 0 24 24">
      <path
        d="M21,10.12H14.22L16.96,7.3C14.23,4.6 9.81,4.5 7.08,7.2C4.35,9.91 4.35,14.28 7.08,17C9.81,19.7 14.23,19.7 16.96,17C18.32,15.65 19,14.08 19,12.1H21C21,14.08 20.12,16.65 18.36,18.39C14.85,21.87 9.15,21.87 5.64,18.39C2.14,14.92 2.11,9.28 5.62,5.81C9.13,2.34 14.76,2.34 18.27,5.81L21,3V10.12M12.5,8V12.25L16,14.33L15.28,15.54L11,13V8H12.5Z"
      />
    </symbol>
    <symbol id="chevronDown" viewBox="0 0 24 24">
      <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
    </symbol>
    <symbol id="playCircle" viewBox="0 0 24 24">
      <path
        d="M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
      />
    </symbol>
    <symbol id="footScanView" viewBox="0 0 24 24">
      <path
        d="M18 6H6A2 2 0 0 0 4 8V16A2 2 0 0 0 6 18H18A2 2 0 0 0 20 16V8A2 2 0 0 0 18 6M18 12H6V9H18M2 4H6V2H2A2 2 0 0 0 0 4V8H2V4M22 2H18V4H22V8H24V4A2 2 0 0 0 22 2M2 16H0V20A2 2 0 0 0 2 22H6V20H2V16M22 20H18V22H22A2 2 0 0 0 24 20V16H22V20"
      />
    </symbol>
    <symbol id="resetCamera" fill="#3f3f3f" viewBox="0 0 24 24">
      <path
        d="M20,5H16.83L15,3H9L7.17,5H4A2,2 0 0,0 2,7V19A2,2 0 0,0 4,21H20A2,2 0 0,0 22,19V7A2,2 0 0,0 20,5M20,19H4V7H8.05L9.88,5H14.12L16,7H20V19M12,18C10.92,18 9.86,17.65 9,17L10.44,15.56C10.91,15.85 11.45,16 12,16A3,3 0 0,0 15,13A3,3 0 0,0 12,10C10.74,10 9.6,10.8 9.18,12H11L8,15L5,12H7.1C7.65,9.29 10.29,7.55 13,8.1C15.7,8.65 17.45,11.29 16.9,14C16.42,16.33 14.38,18 12,18Z"
      />
    </symbol>
    <symbol id="kneeTip" viewBox="0 0 37.21 63.15">
      <path
        fill="#5ec2d6"
        d="M16 .58v62.1a.47.47 0 0 1-.48.46.5.5 0 0 1-.41-.26L0 32.11a.58.58 0 0 1 0-.41L15 .37a.48.48 0 0 1 .61-.37.47.47 0 0 1 .39.58zm5.32 0v62.1a.47.47 0 0 0 .45.47.45.45 0 0 0 .43-.27l15-30.76a.49.49 0 0 0 0-.41L22.16.38a.46.46 0 0 0-.63-.19.5.5 0 0 0-.25.39z"
      />
    </symbol>
    <symbol id="infoCircle" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
      />
    </symbol>
    <symbol id="questionMarkCircle" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z"
      />
    </symbol>

    <symbol id="female-icon" viewBox="0 0 24 24">
      <path
        fill="#eaeaea"
        d="M12,4A6,6 0 0,1 18,10C18,12.97 15.84,15.44 13,15.92V18H15V20H13V22H11V20H9V18H11V15.92C8.16,15.44 6,12.97 6,10A6,6 0 0,1 12,4M12,6A4,4 0 0,0 8,10A4,4 0 0,0 12,14A4,4 0 0,0 16,10A4,4 0 0,0 12,6Z"
      />
    </symbol>

    <symbol id="male-icon" viewBox="0 0 24 24">
      <path
        fill="#eaeaea"
        d="M9,9C10.29,9 11.5,9.41 12.47,10.11L17.58,5H13V3H21V11H19V6.41L13.89,11.5C14.59,12.5 15,13.7 15,15A6,6 0 0,1 9,21A6,6 0 0,1 3,15A6,6 0 0,1 9,9M9,11A4,4 0 0,0 5,15A4,4 0 0,0 9,19A4,4 0 0,0 13,15A4,4 0 0,0 9,11Z"
      />
    </symbol>

    <symbol id="play" viewBox="0 0 24 24">
      <path fill="currentColor" d="M8,5.14V19.14L19,12.14L8,5.14Z" />
    </symbol>

    <symbol id="pause" viewBox="0 0 24 24">
      <path fill="currentColor" d="M14,19H18V5H14M6,19H10V5H6V19Z" />
    </symbol>

    <symbol id="forwards" viewBox="0 0 24 24">
      <path fill="currentColor" d="M4,5V19L11,12M18,5V19H20V5M11,5V19L18,12" />
    </symbol>

    <symbol id="backwards" viewBox="0 0 24 24">
      <path fill="currentColor" d="M20,5V19L13,12M6,5V19H4V5M13,5V19L6,12" />
    </symbol>

    <symbol id="stop" viewBox="0 0 24 24">
      <path d="M18,18H6V6H18V18Z" />
    </symbol>
    <symbol id="chevron-updown" viewBox="0 0 24 24">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7071 4.29289C12.3166 3.90237 11.6834 3.90237 11.2929 4.29289L7.29289 8.29289C6.90237 8.68342 6.90237 9.31658 7.29289 9.70711C7.68342 10.0976 8.31658 10.0976 8.70711 9.70711L12 6.41421L15.2929 9.70711C15.6834 10.0976 16.3166 10.0976 16.7071 9.70711C17.0976 9.31658 17.0976 8.68342 16.7071 8.29289L12.7071 4.29289ZM7.29289 15.7071L11.2929 19.7071C11.6834 20.0976 12.3166 20.0976 12.7071 19.7071L16.7071 15.7071C17.0976 15.3166 17.0976 14.6834 16.7071 14.2929C16.3166 13.9024 15.6834 13.9024 15.2929 14.2929L12 17.5858L8.70711 14.2929C8.31658 13.9024 7.68342 13.9024 7.29289 14.2929C6.90237 14.6834 6.90237 15.3166 7.29289 15.7071Z" />
    </symbol>
    <symbol id="chevron-left" viewBox="0 0 24 24">
      <path fill="currentColor" d="M15.41 16.59L10.83 12L15.41 7.41L14 6L8 12L14 18L15.41 16.59Z"/>
    </symbol>
    <symbol id="chevron-right" viewBox="0 0 24 24">
      <path fill="currentColor" d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z"/>
    </symbol>
    <symbol id="restart" viewBox="0 0 24 24">
      <path fill="currentColor" d="M12 6V3L8 7l4 4V8c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5H5c0 3.87 3.13 7 7 7s7-3.13 7-7-3.13-7-7-7z"/>
    </symbol>
    


    
  </defs>
</svg>
